define ['./coapplicants.css'], () ->
  (RentappService, $state) ->
    restrict: "E"
    template: require("./coapplicants.jade")
    scope: {field: "=", mode: "@", stage: "="}
    link: (scope, element, attrs) ->
      scope.coapplicants = scope.field.value || []
      scope.entered =
        first: ""
        last: ""
        email: ""
        
      scope.addCoapplicant = (first, last, email) ->
        scope.coapplicants.push first: first, last: last, email: email
        scope.field.value = angular.copy(scope.coapplicants)
        scope.clearField()

      scope.removeCoapplicant = (i) ->
        scope.coapplicants.splice i, 1
        scope.field.value = angular.copy(scope.coapplicants)

      scope.clearField = () ->
        scope.entered.first = scope.entered.last = scope.entered.email = ""



// WEBPACK FOOTER //
// ./directives/freeforms/coapplicants/coapplicants.coffee